import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AlertContextProvider } from '../../app/src/contexts/alert';
import { PepeContextProvider } from './contexts/Pepe';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter>
    <AlertContextProvider>
      <PepeContextProvider>
        <App />
      </PepeContextProvider>
    </AlertContextProvider>
  </BrowserRouter>
);
